// ============================================================
// ESTABLISHMENT CARD COMPONENT
// File: src/components/EstablishmentCard.js
// Mobile-friendly card view for establishments
// ============================================================

import React from 'react'
import { useTheme } from '../ThemeContext'

export default function EstablishmentCard({
  establishment,
  onSelect,
  getStatusBadge,
  getLastInspectionDate,
  establishmentType = 'mxb'
}) {
  const { darkMode } = useTheme()
  const { date, status } = getLastInspectionDate(establishment.inspections)

  const mPrimary   = darkMode ? '#c8daf5' : '#1a2a3e'
  const mSecondary = darkMode ? '#7aa0c8' : '#4a6080'
  const mMuted     = darkMode ? '#4a6888' : '#7a96b8'
  const mRowBorder = darkMode ? 'rgba(90,127,173,0.35)' : 'rgba(61,100,148,0.3)'
  const mRowHover  = darkMode ? 'rgba(90,127,173,0.14)' : 'rgba(61,100,148,0.07)'
  const mCardBg    = darkMode ? 'rgba(20,36,58,0.7)'   : 'rgba(255,255,255,0.75)'
  const mAccentBorder = darkMode ? 'rgba(90,127,173,0.5)' : 'rgba(61,100,148,0.4)'

  return (
    <div
      onClick={() => onSelect(establishment)}
      style={{
        backgroundColor: mCardBg,
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        borderRadius: '10px',
        padding: '14px 16px',
        marginBottom: '10px',
        border: `1px solid ${mRowBorder}`,
        cursor: 'pointer',
        transition: 'all 0.15s'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = mRowHover
        e.currentTarget.style.borderColor = mAccentBorder
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = mCardBg
        e.currentTarget.style.borderColor = mRowBorder
      }}
    >
      {/* Header */}
      <div style={{ marginBottom: '10px', position: 'relative' }}>
        {establishmentType === 'mxb' && (
          <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 1 }}>
            {getStatusBadge(status)}
          </div>
        )}
        <div style={{ marginBottom: '4px', paddingRight: establishmentType === 'mxb' ? '100px' : '0' }}>
          <h3 style={{
            margin: 0,
            fontSize: '20px',
            fontWeight: '600',
            color: mPrimary,
            textAlign: 'center',
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            fontFamily: "'EB Garamond', Georgia, serif"
          }}>
            {establishment.trade_name}
          </h3>
        </div>
        <div style={{
          fontSize: '13px',
          color: mMuted,
          fontWeight: '600',
          textAlign: 'center',
          letterSpacing: '0.06em',
          fontFamily: "'Source Sans 3', system-ui, sans-serif",
          textTransform: 'uppercase'
        }}>
          {establishment.mxb_number}
        </div>
      </div>

      {/* Details */}
      <div style={{
        fontSize: '15px',
        color: mSecondary,
        lineHeight: '1.6',
        fontFamily: "'Source Sans 3', system-ui, sans-serif",
        borderTop: `1px solid ${mRowBorder}`,
        paddingTop: '10px'
      }}>
        <div style={{ marginBottom: '2px' }}>{establishment.address}</div>
        <div style={{ marginBottom: '2px' }}>{establishment.city}, {establishment.state} {establishment.zip}</div>
        <div style={{ marginBottom: '2px', color: mMuted, fontSize: '14px' }}>
          {establishment.users ? `${establishment.users.first_name} ${establishment.users.last_name}` : 'Unassigned'}
        </div>
        <div style={{ color: mMuted, fontSize: '14px' }}>Last Checked: {date}</div>
      </div>
    </div>
  )
}
